import React, { ReactNode } from "react";

type CardProps = {
  children: ReactNode;
};

type CardHeaderProps = {
  children: ReactNode;
};

type CardContentProps = {
  children: ReactNode;
};

/**
 * This is a class to test out the Compound Pattern
 * @param param0
 * @returns
 */
const Card: React.FC<CardProps> & {
  Header: React.FC<CardHeaderProps>;
  Content: React.FC<CardContentProps>;
} = ({ children }) => {
  return (
    <div className="card mx-auto flex max-w-md flex-col border p-4">
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child) && child.type === Card.Header) {
          return React.cloneElement(child);
        }
      })}
      {React.Children.map(children, (child) => {
        if (React.isValidElement(child) && child.type === Card.Content) {
          return React.cloneElement(child);
        }
      })}
    </div>
  );
};

const CardHeader: React.FC<CardHeaderProps> = ({ children }) => {
  return <div className="card-header bg-gray-200 p-2">{children}</div>;
};

const CardContent: React.FC<CardContentProps> = ({ children }) => {
  return <div className="card-content bg-white p-4">{children}</div>;
};

Card.Header = CardHeader;
Card.Content = CardContent;

export default Card;
